import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_order_lines_by_shipmentService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { order_id: number, shipment_id: number }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, ShipmentId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil($inParams.shipment_id)) {
      $missingRequiredInParams.push('\'shipment_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { order_id: number, shipment_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, ShipmentId?: number }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil($inParams.shipment_id)) {
      $missingRequiredInParams.push('\'shipment_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { order_id: number, shipment_id: number, $keys: { OrderId?: number, LineNumber?: number }[] }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, ShipmentId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil($inParams.shipment_id)) {
      $missingRequiredInParams.push('\'shipment_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      order_id: number, shipment_id: number    }) {
        if(isNil($inParams.order_id)) {
          return true; 
        }
        if(isNil($inParams.shipment_id)) {
          return true; 
        }
      return false;
    }
}
